module.exports = __webpack_public_path__ + "img/img2_5.ab099162.jpeg";